// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-HKKljmUU-GOE6zbgQDcTr." + "92c1866bc9e885f4" + ".js";
};